export default __webpack_public_path__ + "static/media/3596.f28d9e7e.png";